import { RelayEnvironmentProvider } from 'react-relay';
import { PropsWithChildren, useMemo } from 'react';
import { getEnvironment } from '#definitions/graphql';

export function RelayProvider({ children }: PropsWithChildren) {
  const environment = useMemo(getEnvironment, []);

  return (
    <>
      {/* @ts-ignore https://github.com/facebook/relay/issues/4598 */}
      <RelayEnvironmentProvider environment={environment}>
        {children}
      </RelayEnvironmentProvider>
    </>
  );
}
